import { useRef } from 'react'

/**
 * Custom Hook to check if some value inside the dependency array has changed.
 * If no compare function is passed, shallow comparison is used.
 *
 * @param {*[]} values - dependency array of values to be checked
 * @param {(a: any, b: any) => boolean} isEqualValueFn - a function that returns true if the value is equal
 * @return {boolean} true if any of the values has changed
 *
 * @example
 * const { param1, param2 } = props
 * const hasChanges = useHasChangedValues([param1, param2], (a, b) => typeof a === typeof b)
 */
export function useHasChangedValues(values, isEqualValueFn) {
    const lastValues = useRef([])

    const hasChanges = values.some((value, index) =>
        typeof isEqualValueFn === 'function'
            ? !isEqualValueFn(lastValues.current[index], value)
            : lastValues.current[index] !== value
    )
    if (hasChanges) {
        lastValues.current = [...values]
    }

    return hasChanges
}
